const styles = (theme) => ({
  spacing: 8,
  // color
  statusValue: {
    fontSize: '32px',
    fontWeight: 'bold',
    fontFamiry: theme.typography.fontKanit,
  },
  statusText: {
    borderRadius: 5,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    fontFamiry: theme.typography.fontKanit,
    fontSize: 12,
  },
  table: {
    maxWidth: 250,
  },
  hiddenLine: {
    borderBottom: 0,
    fontSize: '12px',
  },

  // color
  color0: {
    color: '#AED3FF',
  },
  color10: {
    color: '#AEECB7',
  },
  color20: {
    color: '#80C63D',
  },
  color35: {
    color: '#F0D447',
  },
  color50: {
    color: '#F08F36',
  },
  color70: {
    color: '#BE6B27',
  },
  color90: {
    color: '#DB352E',
  },
});

export default styles;
